import RequestAbstract from "../abstract";

export default class CurrencyExchangeRates extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/currency-exchange-rates";
    }
}
